// Разовая миграция: раньше токен сессии лежал в localStorage.
// Если он там остался — обмениваем его на httpOnly-cookie (POST /api/auth/session)
// и удаляем из localStorage. Возвращает пользователя или null.
import axios from 'axios';
import config from '../config';


export const migrateLegacyToken = async () => {
  let legacy = null;
  try {
    legacy = localStorage.getItem('token');
  } catch (e) {
    return null;
  }
  if (!legacy) return null;

  const removeLegacy = () => {
    try { localStorage.removeItem('token'); } catch (e) { /* ignore */ }
  };

  try {
    const response = await axios.post(
      `${config.apiUrl}/api/auth/session`,
      {},
      { headers: { Authorization: `Bearer ${legacy}` }, withCredentials: true }
    );
    removeLegacy();
    return response.data?.user || null;
  } catch (error) {
    // 401 — старый токен невалиден: удаляем и продолжаем как гость.
    // Сетевая ошибка / 5xx — токен оставляем, попробуем при следующем запуске.
    if (error?.response?.status === 401) removeLegacy();
    return null;
  }
};
